import { useContext } from 'react';
import { GlobalStateContext } from '../contexts';

export const useServices = () => useContext(GlobalStateContext);
